export enum eNotificationType {
	// 1 "SELLER_TO_REVIEW"		Solo se usa por email y para el admin
	SELLER_REGISTER_COMPLETE = 2,
	SELLER_REJECTED = 3,		// No se está usando
	// 4 "NEW_USER"				Solo se usa por email
	ACCOUNT_IN_REVIEW = 5,
	ABANDONED_CART = 7,
	PURCHASED_PRODUCT_SELLER = 9,
	PURCHASED_PRODUCT_BUYER = 10,
	ADDED_QUESTION = 11,
	QUESTION_ANSWERED = 12,
	SHIPMENT_PICKED_UP = 13,
	SHIPMENT_IN_PROCESS = 14,
	SHIPMENT_DELIVERED = 15,
	PURCHASE_RECEIVED = 16,
	CUSTOMER_NOT_PRESENT = 17,
	NEW_ECOTREND = 18,
	//FEATURED_AD = 19,			Sin implementar por ahora
	//NEW_AD = 20,				Sin implementar por ahora
	EMITTED_MANUALLY = 21,
	SELLER_UPLOADED_INVOICE = 22
}